import { Component, OnInit } from '@angular/core';
import { Sinalization } from '@models/sinalization';
import { Store, select } from '@ngrx/store';
import { AppState } from '@store/state/app.state';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import * as moment from 'moment';
import { getSinalization } from '@store/selectors/user.selector';

@Component({
    selector: 'app-sinalization-detail',
    templateUrl: './sinalization-detail.component.html',
    styleUrls: ['./sinalization-detail.component.scss'],
    standalone: false
})
export class SinalizationDetailComponent {

  public sinalization: Sinalization;

  private unsubscribe$: Subject<void> = new Subject();

  constructor(public store: Store<AppState>, private readonly activatedRoute: ActivatedRoute) {
    const sinId = this.activatedRoute.snapshot.params.id;

    this.store.pipe(
      select(getSinalization),
      takeUntil(this.unsubscribe$)
    ).subscribe(sinalizations => {
        if (sinalizations) {
          this.sinalization = sinalizations.find(sinalization => sinalization.sid === Number(sinId));
        }
    });

  }
}
